import Link from "../../../../../src/components/link/Link";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Link,
  Playground,
  Props,
  React
};